var styles = {"timeRangeOutput":"styles_time-range-output__jVFEc","separator":"styles_separator__aSEKp"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
